// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"carousel_wrapper__3iADr","title":"carousel_title__3xmPD","item":"carousel_item__3zk67","carousel":"carousel_carousel__39bTl"};